import { useBooleanFlag } from '@trm/feature-flags/web';

export const useSocialLoginFlag = () => ({
  isSocialLoginEnabled: useBooleanFlag('enable-social-login', false),
});
